import React, { useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const initials = (name) => (name ? name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'U');

export const UserAvatar = ({ user, size = 'w-10 h-10', className = '', textClass = 'text-sm', version }) => {
  const [failed, setFailed] = useState(false);
  const token = localStorage.getItem('srm_token');
  const src = user?.avatar_path && token && !failed
    ? `${BACKEND_URL}/api/profile/avatar/${user.id}?auth=${token}${version ? `&v=${version}` : ''}`
    : null;

  return (
    <div
      className={`${size} rounded-full border-2 border-[#D4AF37]/40 bg-[#1F1B71] flex items-center justify-center overflow-hidden shrink-0 ${className}`}
      data-testid={`avatar-${user?.id || 'unknown'}`}
    >
      {src ? (
        <img src={src} alt={user?.full_name || 'avatar'} className="w-full h-full object-cover" onError={() => setFailed(true)} />
      ) : (
        <span className={`text-[#D4AF37] font-bold ${textClass}`}>{initials(user?.full_name)}</span>
      )}
    </div>
  );
};
